import { o_util } from "@gr-common/async/namespaces";
const core = o_util.core ?? {};
const isEmptyObject = core.isEmptyObject;
const isPlainObject = core.isPlainObject;
const runWithMicrotask = core.runWithMicrotask;
const runWithMacrotask = core.runWithMacrotask;
const runWithAnimationFrame = core.runWithAnimationFrame;
const runWithRenderSlice = core.runWithRenderSlice;
const coerce = core.coerce;
const deserialize = core.deserialize;
const serialize = core.serialize;
const serializeForm = core.serializeForm;
export {
  coerce,
  core,
  deserialize,
  isEmptyObject,
  isPlainObject,
  runWithAnimationFrame,
  runWithMacrotask,
  runWithMicrotask,
  runWithRenderSlice,
  serialize,
  serializeForm
};
